import { ChangeEvent, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom/client";
import { useGetPopups } from "hooks/common/useGetPopups";
import { RouteTypes } from "hooks/utils/util";

type LayerProps = {
    data: any;
    index: number;
    totalCount: number;
    popupIdxsArray: number[];
    setPopupIdxsArray: React.Dispatch<React.SetStateAction<number[]>>;
};
type PopupProps = {
    data: any;
};
const Layer = ({ data, index, totalCount, popupIdxsArray, setPopupIdxsArray }: LayerProps) => {
    const [checked, setChecked] = useState(false);
    const popupRef = useRef<HTMLDialogElement | null>(null);
    const ratio = data.vPopSizeW / data.vPopSizeH;
    const isAvailableOneDayViewing = data.cTodayYN === "Y";
    // 쿠키에 저장돼있는 팝업 Array
    const popupCookies = document.cookie;
    const popupArray = popupCookies.split("popup=").filter(Boolean);

    //쿠키 생성
    function setCookie(name: string, value: string, day: number) {
        let date = new Date(); //현재 날짜 지정.
        date.setDate(date.getDate() + day);

        let popupCookie = "";
        popupCookie += document.cookie;
        popupCookie += name + "=" + value + ";";
        popupCookie += "Expires=" + date.toUTCString();
        document.cookie = popupCookie; //쿠키 설정, 생성
    }

    const handleClosePopup = (value: string | undefined, popup_id: string) => {
        setPopupIdxsArray(prev => prev!.filter(idx => idx !== Number(popup_id)));

        if (value !== "true") return;

        // 팝업을 다시 안보겠다. 팝업 닫고, 쿠키 생성.
        setCookie("popup", popup_id, 1);
    };

    return (
        <dialog
            open={!popupArray.includes(data.idx.toString())}
            onClose={() => handleClosePopup(popupRef.current?.returnValue, data.idx)}
            ref={popupRef}
            title={data.vTitle}
            style={{
                position: "fixed",
                left: `${data.vPopX}px`,
                top: `${data.vPopY}px`,
                transform: "none",
                zIndex: 100 + (totalCount - index),
                margin: 0,
                pointerEvents: "auto",
                boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.25)",
                borderRadius: "16px",
                overflow: "hidden",
            }}
        >
            <div
                style={{
                    width: `${data.vPopSizeW}px`,
                    height: `${data.vPopSizeH}px`,
                    overflow: "hidden",
                    aspectRatio: ratio,
                    padding: 20,
                }}
            >
                <div dangerouslySetInnerHTML={{ __html: data.vContent || "" }}></div>
            </div>

            <form method="dialog">
                <div className="bg-[#333] h-[40px] flex justify-between items-center px-[15px]">
                    {isAvailableOneDayViewing && (
                        <label htmlFor={`cTodayYN-${index}`} className="flex items-center gap-2 text-white">
                            <input
                                type="checkbox"
                                name={`cTodayYN-${index}`}
                                id={`cTodayYN-${index}`}
                                checked={checked}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => setChecked(e.target.checked)}
                            />
                            오늘 하루 안보기
                        </label>
                    )}
                    <button
                        className="ml-auto text-white flex items-center gap-[5px]"
                        onClick={() => (isAvailableOneDayViewing ? popupRef.current?.close(`${checked}`) : undefined)}
                    >
                        창닫기
                    </button>
                </div>
            </form>
        </dialog>
    );
};

const Popup = ({ data }: PopupProps) => {
    return <div dangerouslySetInnerHTML={{ __html: data.vContent || "" }}></div>;
};

export default function MainPopups({ type }: { type: RouteTypes }) {
    const { data } = useGetPopups({ category: type });
    const [popupIdxsArray, setPopupIdxsArray] = useState<number[]>([]);

    // useEffect(() => {
    //     if (data) {
    //         const popupIdxs = data.map(popup => popup.idx);
    //         setPopupIdxsArray(popupIdxs);
    //     }
    // }, [data]);

    useEffect(() => {
        data?.forEach((popup, index) => {
            const isAvailableOneDayViewing = popup.cTodayYN === "Y";
            const popupCookies = document.cookie;
            const popupArray = popupCookies.split("popup=").filter(Boolean);

            if (popupArray.includes(popup.idx.toString())) return;

            if (popup.cPvL === "P") {
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                const height = Number(popup.vPopSizeH) + (isSafari ? 66 : 40);

                const popupWindow = window.open("", "", `width=${popup.vPopSizeW},height=${height},left=${popup.vPopX},top=${popup.vPopY}`);

                if (!popupWindow) return;

                popupWindow.document.write(`
                    <!DOCTYPE html>
                    <html lang="ko">
                        <head>
                            <title>${popup.vTitle}</title>
                            <meta charset="UTF-8" />
                            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                            <style>
                                html, body { padding: 0; margin: 0; }
                                #popup-root { overflow: auto; }
                                #popup-root>div>p { margin: 0; }
                                #popup-root>div>p img { vertical-align: top; }
                                .action-bar { background: #333; height: 40px; display:flex; justify-content: space-between; align-items: center; padding:0 15px; } 
                                .action-bar label { color: white; display:${isAvailableOneDayViewing ? "block" : "none"}} 
                                .action-bar button { margin-left: auto;} 
                            </style>
                        </head>
                        <body>
                            <div id="popup-root"></div>
                           
                            <form name="form">
                                <div class="action-bar">
                                    <label for="cTodayYN">
                                        <input type="checkbox" name="cTodayYN" id="cTodayYN" />
                                        오늘 하루 안보기
                                    </label>
                                    <button>창닫기</button>
                                </div>
                            </form>
                         
                            <script>
                                function setCookie(name, value, day) {
                                    let date = new Date();
                                    date.setDate(date.getDate() + day);

                                    let popupCookie = "";
                                    popupCookie += document.cookie;
                                    popupCookie += name + "=" + value + ";";
                                    popupCookie += "Expires=" + date.toUTCString();
                                    document.cookie = popupCookie;
                                }

                                document.form.onsubmit = function (event) {
                                   event.preventDefault();
                                   const formData = new FormData(event.currentTarget)
                                   const cTodayYN = formData.get("cTodayYN");

                                   if(cTodayYN === 'on'){
                                    setCookie("popup", ${popup.idx}, 1);
                                   }
                                   window.close();
                                };
                            </script>
                        </body>
                    </html>
                `);

                popupWindow.document.close();

                const interval = setInterval(() => {
                    const container = popupWindow.document.getElementById("popup-root") as HTMLElement;
                    if (container) {
                        clearInterval(interval);

                        const root = ReactDOM.createRoot(container);

                        root.render(<Popup data={popup} />);
                    }
                }, 100);
            }
        });
    }, [data]);

    return (
        <>
            {data ? (
                <>
                    {data.map((popup, index) => {
                        if (popup.cPvL === "L") {
                            return (
                                <Layer
                                    key={popup.idx}
                                    data={popup}
                                    index={index}
                                    totalCount={data.length}
                                    popupIdxsArray={popupIdxsArray}
                                    setPopupIdxsArray={setPopupIdxsArray}
                                />
                            );
                        } else {
                            return null;
                        }
                    })}
                </>
            ) : null}
        </>
    );
}
